import React from 'react';
import { connect } from 'react-redux';
import { findWithUUID } from '@/utils/uuidHelper';
import { updateActiveField } from '../../dictionaries/actions';
import DictionaryFieldDropdown from '../components/DictionaryFieldDropdown';

const DictionaryFieldChanger = ({
  changeField,
  fields,
  fieldUUID,
  saveErrors,
}) => {
  if (fields.length === 1) {
    return (<p className="aridhia-dictionary-field-dropdown-single" title={fields[0].name}>{fields[0].name}</p>);
  }

  return (
    <DictionaryFieldDropdown
      className="aridhia-dictionary-field-changer"
      errors={saveErrors.map((error) => error.context.lookupName)}
      fieldIdentifier={fieldUUID}
      fields={fields}
      inline
      onChange={changeField}
    />
  );
};

const mapStateToProps = ({
  datasets: {
    lookups: {
      dictionaries, activeDictionaryUUID, activeFieldUUID, saveErrors,
    },
  },
}) => {
  const dictionary = findWithUUID(dictionaries, activeDictionaryUUID) || { fields: [] };
  return ({ fields: dictionary.fields, fieldUUID: activeFieldUUID, saveErrors });
};

const mapDispatchToProps = {
  changeField: updateActiveField,
};

export default connect(mapStateToProps, mapDispatchToProps)(DictionaryFieldChanger);
